var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisaIntable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visa_intable",
    transform: "translate(-396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8_visa",
    transform: "translate(403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46982",
    "data-name": "Path 46982",
    d: "M37,29.8A3.219,3.219,0,0,1,33.762,33H6.238A3.219,3.219,0,0,1,3,29.8V12.2A3.219,3.219,0,0,1,6.238,9H33.762A3.219,3.219,0,0,1,37,12.2Z",
    transform: "translate(-3 -9)",
    fill: "#e5f1fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46983",
    "data-name": "Path 46983",
    d: "M13.841,19l-2.126,6.266s-.54-2.65-.593-2.983c-1.21-2.729-3-2.577-3-2.577l2.1,8.094v0H12.79L16.328,19Zm2.026,8.8h2.324L19.6,19H17.244ZM32.316,19H29.871l-3.813,8.8h2.309l.476-1.257h2.911L32,27.8h2.115Zm-2.829,5.862,1.265-3.326.662,3.326Zm-6.593-3.3c0-.485.4-.846,1.559-.846a3.7,3.7,0,0,1,1.612.539l.377-1.847A7.168,7.168,0,0,0,24.264,19c-2.444,0-3.7,1.155-3.7,2.618,0,2.645,3.221,2.282,3.221,3.641,0,.233-.187.771-1.528.771a5.023,5.023,0,0,1-2.233-.487l-.4,1.773a5.514,5.514,0,0,0,2.523.485c1.667,0,3.979-1.232,3.979-3C26.12,22.669,22.894,22.515,22.894,21.565Z",
    transform: "translate(-3.976 -11)",
    fill: "#1565c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46984",
    "data-name": "Path 46984",
    d: "M10.883,23.79l-.782-3.8a1.434,1.434,0,0,0-1.273-.823H5.233S9.816,20.506,10.883,23.79Z",
    transform: "translate(-3.425 -11.034)",
    fill: "#ffc107"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12266",
    "data-name": "Rectangle 12266",
    width: 48,
    height: 24,
    transform: "translate(396)",
    fill: "#fff",
    opacity: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIntable);
export default __webpack_public_path__ + "static/media/visa_intable.d7e39587e9089678c7c007ed93a4feda.svg";
export { ForwardRef as ReactComponent };